/**
 * @file depConfig.js，依赖配置
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-11-29 Baidu
 */

export let envConfig = () => {
    let config;
    // 开发环境
    if (process.env.NODE_ENV === 'development') {
        config = {
            passportUrl: 'https://passport.qatest.baidu.com',
            dwzBaiduDomain: 'https://dwzpassport-test.baidu.com',
            // dwzDomain: 'https://dwz.nuomi.com',
            dwzDomain: 'http://test.dwz.cn',
            bceUrl: 'https://qasandbox.bcetest.baidu.com'
        };
    }
    // 线上
    else {
        config = {
            passportUrl: 'https://passport.baidu.com',
            dwzBaiduDomain: 'https://dwzpassport.baidu.com',
            dwzDomain: 'https://dwz.cn',
            bceUrl: 'https://console.bce.baidu.com'
        };
    }
    return config;
};
